import { Injectable } from '@angular/core';

import { InternalUserSessionService } from './internal.user-session.service';

export const USER_SESSION_ID = 'userSessionId';

/**
 * This service provides a session id identifying the user across page reloads until
 * he closes all tabs. The user session is propagated across tabs when using the
 * InterSpaRouter from b2e-utils-ng-jslib.
 *
 * This service is just a wrapper around the actual service to only expose
 * the getId method.
 */
@Injectable({
    providedIn: 'root'
})
export class UserSessionService {
    // eslint-disable-next-line @angular-eslint/prefer-inject
    constructor(private internalUserSession: InternalUserSessionService) {}

    getId(): string {
        return this.internalUserSession.getId();
    }
}
